<add-movin-coin (sendEvent)="openStripe($event)" [type]="1"></add-movin-coin>
<app-stripe-payment #stripePayment (sendBuyEvent)="save($event)"></app-stripe-payment>

